import axios from 'axios';

// Auto-detect environment and determine backend URL
const getBackendURL = () => {
  if (!process.env.REACT_APP_BACKEND_URL) throw new Error('REACT_APP_BACKEND_URL is required');
  return process.env.REACT_APP_BACKEND_URL.replace(/\/$/, '');
};

const API_URL = getBackendURL();

console.log('[API Config] Hostname:', window.location.hostname);
console.log('[API Config] Backend URL:', API_URL);

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Export the backend URL getter for use in other components
export const getBackendUrl = getBackendURL;

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  login: (email, password) => api.post('/api/auth/login', { email, password })
};

// Admin API
export const adminAPI = {
  // Axios methods bound to the instance
  get: (...args) => api.get(...args),
  post: (...args) => api.post(...args),
  put: (...args) => api.put(...args),
  delete: (...args) => api.delete(...args),
  // Helper methods
  listClients: () => api.get('/api/clients'),
  getClient: (clientId) => api.get(`/api/clients/${clientId}`),
  verifyID: (clientId, verified) => 
    api.post(`/api/clients/${clientId}/verify-id`, { verified }),
  markComplete: (clientId) => api.post(`/api/clients/${clientId}/mark-complete`),
  resendLink: (sessionId) => api.post(`/api/clients/${sessionId}/resend-link`)
};

// Onboarding API (public)
export const onboardingAPI = {
  getSession: (token) => api.get(`/api/onboarding/${token}`),
  saveData: (token, data, progress, status) => 
    api.put(`/api/onboarding/${token}/save`, { data, progress, status }),
  uploadDocument: (token, file, docType) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/api/onboarding/${token}/upload?doc_type=${docType}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  previewAgreement: (token) => api.get(`/api/onboarding/${token}/agreement`),
  signAgreement: (token, signatureImage, signedName, consents, versionHash) => 
    api.post(`/api/onboarding/${token}/sign`, {
      signature_image: signatureImage,
      signed_name: signedName,
      consents,
      version_hash: versionHash
    }),
  completeOnboarding: (token) => api.post(`/api/onboarding/${token}/complete`)
};

// Documents API
export const documentsAPI = {
  download: (docId, token = null) => {
    const url = token ? 
      `${API_URL}/api/documents/${docId}?token=${token}` : 
      `${API_URL}/api/documents/${docId}`;
    return url;
  }
};

export default api;